<template>
  <div class="lxm-tabs tabs is-centered is-boxed">
    <ul>
      <template v-for="tab in tabs">
        <li :class="{ 'is-active': tab.active }">
          <a @click="tabClicked(tab.to)">
            <span>{{ tab.name }}</span>
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-tabs
    &.tabs
      &:not(:last-child)
        margin-bottom: 0
      ul
        border-bottom: siz(1.5) solid grey-white
      li
        margin: 0 siz(55 / 4)
      &.is-boxed
        a
          width: siz(90)
          font-size: size-big
          border: 0
          border-radius: siz(7.5) siz(7.5) 0 0
          padding-bottom: siz(6)
          padding-top: siz(6)
          background-color: grey-white
          line-height: 1
        li.is-active a
          color: white
          background-color: brand-primary
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'
  export default {
    props: {
      tabs: Array
    },
    methods: {
      tabClicked (to) {
        // 不向 history 添加新记录
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.replace(to)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmTabs.vue?18f5c17c